// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__D6gx4","site":"NavBar_site__rqWOC"};